var menu = [
  {
    title: "Arts Organizations",
    href: "",
    id: "arts",
    children: [
      {
        title: "All",
        filter: 'all'
      },
      {
        title: "Broadcast, Media, and Literary Arts",
        filter: 5
      },
      {
        title: "Community",
        filter: 3
      },
      {
        title: "Education",
        filter: 7
      },
      {
        title: "Museums, Visual Arts, and History",
        filter: 4
      },
      {
        title: "Performing Arts",
        filter: 6
      },
      {
        title: "Support and Advocacy",
        filter: 1
      },
      {
        title: "Multidisciplinary",
        filter: 2
      },
      {
        title: "Non-Profit",
        filter: 'nonProfit'
      },
      {
        title: "City-Owned",
        filter: 'cityOwned'
      },
    ]
  },
  {
    title: "Transit",
    href: "",
    id: "transit",
    children: [
      {
        title: "BART",
        id: "bartTracks",
        layer: true,
        children: [
          {
            title: "BART tracks",
            id: "bartTracks",
            layer: true
          },
          {
            title: "BART stations",
            id: "bartStations",
            layer: true
          },
        ]
      },
      {
        title: "MUNI",
        id: "muni",
        layer: true,
        children: [
          {
            title: "MUNI metro",
            id: "muni",
            layer: true
          },
          {
            title: "Planned metro",
            id: "muniPlanned",
            layer: true
          },
          {
            title: "MUNI bus",
            id: "busRoutes",
            layer: true,
          },
          {
            title: "Planned Bus Rapid Transit",
            id: "muniBRTPlanned",
            layer: true
          }
        ]
      },
      {
        title: "Caltrain",
        id: "caltrain",
        layer: true,
        children: [
          {
            title: "Caltrain tracks",
            id: "caltrain",
            layer: true
          },
          {
            title: "Planned Caltrain",
            id: "caltrainPlanned",
            layer: true
          }
        ]
      },
      {
        title: "Bike Routes",
        id: "bikeways",
        layer: true,
      }
    ]
  },
  {
    title: "Demographics",
    href: "",
    id: "demographics",
    children: [
      {
        title: "Population",
        id: "censusPopulation",
        layer: true,
        exclusive: true,
        group: "census",
        children: [
          {
            title: "Population",
            legend: true,
            id: "censusPopulation",
            labels: "censusPopulationLabels",
            group: "census",
            exclusive: true,
            min: 0,
            max: "11.5k"
          },
          {
            title: "Density",
            legend: true,
            id: "censusDensity",
            labels: "censusDensityLabels",
            group: "census",
            exclusive: true,
            min: 0,
            max: "11.5k",
          },
        ]
      },
      {
        title: "Income",
        id: "income0",
        layer: true,
        exclusive: true,
        group: "census",
        children: [
          {
            title: "<25k",
            id: "income0",
            labels: "income0Labels",
            type: "layer",
            legend: true,
            group: "census",
            exclusive: true,
            min: 0,
            max: 832
          },
          {
            title: "25-50k",
            id: "income1",
            labels: "income1Labels",
            type: "layer",
            legend: true,
            group: "census",
            exclusive: true,
            min: 0,
            max: 809
          },
          {
            title: "50-75k",
            id: "income2",
            labels: "income2Labels",
            type: "layer",
            legend: true,
            group: "census",
            exclusive: true,
            min: 0,
            max: 324
          },
          {
            title: "75-100k",
            id: "income3",
            labels: "income3Labels",
            type: "layer",
            legend: true,
            group: "census",
            exclusive: true,
            min: 0,
            max: 327
          },
          {
            title: "100k+",
            id: "income4",
            labels: "income4Labels",
            type: "layer",
            legend: true,
            group: "census",
            exclusive: true,
            min: 0,
            max: 238
          }
        ]
      },
      {
        title: "Race / Ethnicity",
        id: "censusAsian",
        layer: true,
        exclusive: true,
        group: "census",
        children: [
          {
            title: "Asian/Asian American",
            id: "censusAsian",
            labels: "censusAsianLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "4.7k"
          },
          {
            title: "Black/African American",
            id: "censusBlack",
            labels: "censusBlackLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "2.2k",
          },
          {
            title: "Hawaiian/Pacific Islander",
            id: "censusHawaiian",
            labels: "censusHawaiianLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "6.7k",
          },
          {
            title: "Hispanic/Latino",
            id: "censusHispanic",
            labels: "censusHispanicLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "3.4k",
          },
          {
            title: "Native American",
            id: "censusNative",
            labels: "censusNativeLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "3.4k",
          },
          {
            title: "White",
            id: "censusWhite",
            labels: "censusWhiteLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "6.7k",
          },
          {
            title: "Other",
            id: "censusOther",
            labels: "censusOtherLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "6.7k",
          }
        ]
      },{
        title: "Age",
        id: "age5",
        layer: true,
        exclusive: true,
        group: "census",
        children: [
          {
            title: "0-5 years",
            id: "age5",
            labels: "age5Labels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
          {
            title: "5-20 years",
            id: "age20",
            labels: "age20Labels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
          {
            title: "20-40 years",
            id: "age40",
            labels: "age40Labels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
          {
            title: "40-60 years",
            id: "age60",
            labels: "age60Labels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
          {
            title: "60-80 years",
            id: "age80",
            labels: "age80Labels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
          {
            title: "80+ years",
            id: "age80plus",
            labels: "age80PlusLabels",
            type: "layer",
            group: "census",
            exclusive: true,
            legend: true,
            min: 0,
            max: "200"
          },
        ]
      }
    ]
   },
   {
    title: "Land Use",
    href: "",
    id: "landuse",
    group: "landuse",
    children: [
      {
        title: "Special Districts",
        id: "investInNeighborhoodsDistricts",
        exclusive: true,
        group: "landuse",
        children: [
          {
            title: "Invest in Neighborhoods District",
            id: "investInNeighborhoodsDistricts",
            exclusive: true,
            group: "landuse"
          },
          {
            title: "Community Benefit Districts",
            id: "communityBenefitDistricts",
            exclusive: true,
            group: "landuse"
          },
          {
            title: "Green Benefit Districts",
            id: "greenBenefitDistricts",
            exclusive: true,
            group: "landuse"
          },
          {
            title: "Cultural Districts",
            id: "culturalDistricts",
            exclusive: true,
            group: "landuse"
          },
        ]
      },
      {
        title: "Zoning",
        id: "zoningResidential",
        layer: true,
        exclusive: true,
        group: "landuse",
        children: [
          {
            title: "Residential",
            id: "zoningResidential",
            type: "layer",
            group: "landuse",
            exclusive: true,
          },
          {
            title: "Commercial",
            id: "zoningComercial",
            type: "layer",
            group: "landuse",
            exclusive: true,
          },
          {
            title: "Mixed Use",
            id: "zoningMixeduse",
            type: "layer",
            group: "landuse",
            exclusive: true,
          },
          {
            title: "Public",
            id: "zoningPublic",
            type: "layer",
            group: "landuse",
            exclusive: true,
          },
          {
            title: "PDR",
            id: "zoningIndustrial",
            type: "layer",
            group: "landuse",
            exclusive: true,
          },
        ]
      },
      {
        title: "Development Pipeline",
        id: "devPipelineResidential",
        group: "pipeline",
        exclusive: true,
        layer: true,
        children: [
          {
            title: "Residential",
            id: "devPipelineResidential",
            group: "pipeline",
            exclusive: false,
            layer: true
          },
          {
            title: "Mixed Use",
            id: "devPipelineMixeduse",
            group: "pipeline",
            exclusive: false,
            layer: true
          },
        ]
      },
      {
        title: "Art Requirements",
        id: "2percentArts",
        group: "landuse",
        exclusive: true,
        layer: true,
        children: [
          {
            title: "2% for Art Requirement",
            id: "2percentArts",
            group: "landuse",
            exclusive: false,
            layer: true
          },
          {
            title: "1% for Art Requirement",
            id: "1percentArts",
            group: "landuse",
            exclusive: false,
            layer: true
          }
        ]
      },
    ],
  },
]

export default menu



// WEBPACK FOOTER //
// ./src/data/menu.js